import { putAPI } from "../../api/api";
import {  REACT_APP_CANDIDATE_FRELLANCER } from "../../utils/common";


export async function submitDetails(data: any){
    const Details = putAPI( REACT_APP_CANDIDATE_FRELLANCER + `/certification`, data)
    return Details
}

export async function removeDetails(data: any){
    const Details = putAPI( REACT_APP_CANDIDATE_FRELLANCER + `/remove-certification`, data)
    return Details
}



